import FormattedDateWithAMPMTimeRenderer from '../../../../core/table/renderers/FormattedDateWithAMPMTimeRenderer';
import CurrencyRenderer from '../../../../core/table/renderers/CurrencyRenderer';
import { tblSpecAddColumn } from '../../../../core/table/spec';
import { TblCol } from '../../../../core/table/table.types';
import { TblViewSpec } from '../../../../core/table/table-view.types';

export type ColKey =
    | ''
    | 'OrderNum'
    | 'Type'
    | 'CEID'
    | 'VendorName'
    | 'VendorInvoiceNum'
    | 'TotalAmount'
    | 'DateCreated'
    | 'VendorInvoiceDate'
    | 'InvoiceReconciledDate';

export function splitOrderInvoicesListColumnSpec(): Map<ColKey, TblCol> {
    const map = new Map<ColKey, TblCol>();

    // Order Info section
    tblSpecAddColumn<ColKey>(map, 'OrderNum', { width: '100px', title: 'Order #' });
    tblSpecAddColumn<ColKey>(map, 'Type', { width: '80px', title: 'Type' });

    // CEID section
    tblSpecAddColumn<ColKey>(map, 'CEID', { width: '100px', title: 'CEID' });

    // Vendor Info section
    tblSpecAddColumn<ColKey>(map, 'VendorName', { width: '140px', title: 'Name' });
    tblSpecAddColumn<ColKey>(map, 'VendorInvoiceNum', { width: '120px', title: 'Invoice #' });
    tblSpecAddColumn<ColKey>(
        map,
        'TotalAmount',
        { type: 'CURRENCY', width: '100px', title: 'Amount' },
        CurrencyRenderer,
    );

    // Process Dates section
    tblSpecAddColumn<ColKey>(
        map,
        'DateCreated',
        { type: 'DATE', width: '130px', title: 'Order Placed' },
        FormattedDateWithAMPMTimeRenderer,
    );
    tblSpecAddColumn<ColKey>(
        map,
        'VendorInvoiceDate',
        { type: 'DATE', width: '130px', title: 'Invoiced' },
        FormattedDateWithAMPMTimeRenderer,
    );
    tblSpecAddColumn<ColKey>(
        map,
        'InvoiceReconciledDate',
        { type: 'DATE', width: '130px', title: 'Reconciled' },
        FormattedDateWithAMPMTimeRenderer,
    );

    return map;
}

export function splitOrderInvoicesListAllColumnsView(): TblViewSpec {
    return splitOrderInvoicesListViewByCe(true);
}

export function splitOrderInvoicesListViewByCe(showCeid: boolean): TblViewSpec {
    const sections = [
        {
            title: 'Order Info',
            cols: ['OrderNum', 'Type'],
        },
        ...(showCeid
            ? [
                  {
                      title: 'CEID',
                      cols: ['CEID'],
                  },
              ]
            : []),
        {
            title: 'Vendor Info',
            cols: ['VendorName', 'VendorInvoiceNum', 'TotalAmount'],
        },
        {
            title: 'Process Dates',
            cols: ['DateCreated', 'VendorInvoiceDate', 'InvoiceReconciledDate'],
        },
    ];
    return {
        key: showCeid ? '1' : 'no-ceid',
        title: 'All',
        sections,
        sortby: '-VendorInvoiceDate',
    };
}
